import * as React from 'react'
import FontIcon from '@luminopia/react-toolbox/lib/font_icon'
import * as styles from './icon-button.css'

interface IProps {
  onClick?: () => void
  iconName: string
}

export class IconButton extends React.PureComponent<IProps, {}> {
  public render() {
    return <FontIcon className={styles.button} value={this.props.iconName} onClick={this.props.onClick} />
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/button/icon-button.tsx